function Weeks() {
    return (
      <section className="container-fluid p-5 position-relative" style={{ zIndex: '-2'}}>
        <div className="row justify-content-md-center g-5 text-white">
          <div className="col-lg-2">
            <div className="p-3 text-center" style={{ backgroundColor: "#f39322", height: '270px' }}>
                <h3>Week 01</h3>
                <p>See Dubai</p>
                <p>
                  In the first week, you will study the geographic segmentation of
                  the Dubai market.
                </p>
              </div>
            </div>
            <div className="col-lg-2">
              <div className="p-3 text-center" style={{ backgroundColor: "#f39322", height: '270px' }}>
                <h3>Week 02</h3>
                <p>Know Dubai</p>
                <p>
                  In the second week, you will study the socio cultural segmentation of the Dubai market.
                </p>
              </div>
            </div>
           <div className="col-lg-2">
              <div className="p-3 text-center" style={{ backgroundColor: "#f39322", height: '270px' }}>
                <h3>Week 03</h3>
                <p>Meet Dubai</p>
                <p>
                  In the third week, you will get into firmographic segmentation, meeting the business honchos.
                </p>
              </div>
            </div>
          </div>
          <div className="row justify-content-md-center g-5 mt-2 text-white">
           <div className="col-lg-2">
              <div className="p-3 text-center" style={{ backgroundColor: "#f39322", height: '270px' }}>
                <h3>Week 04</h3>
                <p>Feel Dubai</p>
                <p>
                  In fourth week, you will study get a deeper understanding of cultural and social habit of Dubai.
                </p>
              </div>
            </div>
           <div className="col-lg-2">
              <div className="p-3 text-center" style={{ backgroundColor: "#f39322", height: '270px' }}>
                <h3>Week 05</h3>
                <p>Live Dubai</p>
                <p>
                  In the last week, you will be introduced to the demographic segmentation of the Dubai market.
                </p>
              </div>
            </div>
          </div>
        </section>
    );
  }
  
  export default Weeks;